import CaireStyle from './CaireStyle';
export default CaireStyle;
